/* eslint-disable react/display-name */
import { forwardRef } from "react";

import { Core, Password, DigitSeparated, Date, TextArea } from "./Variants";

const Input = forwardRef(
  (
    {
      label,
      required,
      size,
      name,
      prefix,
      suffix,
      mask,
      gridArea,
      margin,
      error,
      ...rest
    },
    ref,
  ) => {
    switch (rest?.type) {
      case "password":
        return (
          <Password
            ref={ref}
            label={label}
            required={required}
            size={size}
            name={name}
            prefix={prefix}
            suffix={suffix}
            mask={mask}
            gridArea={gridArea}
            margin={margin}
            error={error}
            {...rest}
          />
        );
      case "digit-separated":
        return (
          <DigitSeparated
            ref={ref}
            label={label}
            required={required}
            size={size}
            name={name}
            prefix={prefix}
            suffix={suffix}
            mask={mask}
            gridArea={gridArea}
            margin={margin}
            error={error}
            {...rest}
          />
        );
      case "date":
      case "datetime-local":
        return (
          <Date
            ref={ref}
            label={label}
            required={required}
            size={size}
            name={name}
            prefix={prefix}
            suffix={suffix}
            mask={mask}
            gridArea={gridArea}
            margin={margin}
            error={error}
            {...rest}
          />
        );

      case "textarea":
        return (
          <TextArea
            ref={ref}
            label={label}
            required={required}
            size={size}
            name={name}
            prefix={prefix}
            suffix={suffix}
            mask={mask}
            gridArea={gridArea}
            margin={margin}
            error={error}
            {...rest}
          />
        );

      default:
        return (
          <Core
            ref={ref}
            label={label}
            required={required}
            size={size}
            name={name}
            prefix={prefix}
            suffix={suffix}
            mask={mask}
            gridArea={gridArea}
            margin={margin}
            error={error}
            {...rest}
          />
        );
    }
  },
);

export default Input;
